import React, { Component } from "react";
import config from "react-global-configuration";
import RequestApi from "../Miscelania/RequestApi";

import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Link } from "react-router-dom";

import Topo from "../Layout/Topo";
import Overlay from "../Miscelania/Overlay";
import Select from "react-select";

class ScheduleGradesExpirationsControl extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: "",
        type: "",
        status: "closed",
      },
      redirect_url: false,
      loaded: 0,
      schedule_grade: [],
      schedule_grades_list: [],
      open: 0,
      table_index: [],
      schedule_grade_group_staffs: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.search = this.search.bind(this);
    this.loadData = this.loadData.bind(this);
    this.export = this.export.bind(this);
  }

  handleSelectChange(name, event) {
    var change = {};
    if (event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeMulti(name, event) {
    var change = {};
    if (event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if (mode === "reset") {
      this.setState({ overlay: { message: "", type: "", status: "closed" } });
    } else {
      this.setState({
        overlay: { message: message, type: type, status: status },
      });
    }
  }
  handleMessage() {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== "undefined") {
      message = JSON.parse(message);
      var self = this;
      self.setState({
        overlay: {
          message: message.alert_message,
          type: message.alert_type,
          status: "open",
        },
      });
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if (this.state.loaded !== 2) {
      this.setState({ loaded: state });
    }
  }
  componentDidMount() {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({ loaded: 2 }, this.loadData());
    }
  }

  loadData(event) {
    var self = this;
    var header = this.refs.request_api.header("application/json");
    Promise.resolve(header).then(function (value) {
      fetch(config.get("api") + "/escala/grade/vencimentos", {
        method: "GET",
        mode: "cors",
        headers: value,
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "url");
          if (responseJson.status === "success") {
            self.setState({
              schedule_grades_list: responseJson.data.schedule_grades_list,
            });
          }
        })
        .then(() => {
          if (typeof event !== "undefined") {
            self.handleAlert(event.message, event.status, "open");
          }
        }); /* Overlay */
    });
  }

  search(event) {
    event.preventDefault();
    this.setState({ overlay: { message: "", type: "", status: "open" } });
    var datasave = {
      schedule_grade_id: this.state.schedule_grade_id,
    };
    var self = this;
    var header = this.refs.request_api.header("application/json");
    Promise.resolve(header).then(function (value) {
      fetch(config.get("api") + "/escala/grade/vencimentos/pesquisa", {
        method: "POST",
        mode: "cors",
        headers: value,
        body: JSON.stringify(datasave),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "alert");
          if (responseJson.status === "success") {
            self.setState({
              schedule_grade_group_staffs:
                responseJson.data.schedule_grade_group_staffs,
              table_index: responseJson.data.table_index,
              open: 1,
            });
          }
          self.setState({
            overlay: {
              message: responseJson.message,
              type: responseJson.status,
              status: "closed",
            },
          });
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  export(event) {
    this.handleAlert("", "", "open");
    var datasave = {
      schedule_grade_id: this.state.schedule_grade_id,
    };
    var header = this.refs.request_api.header("application/json");
    var self = this;
    self.handleAlert("", "", "open");
    Promise.resolve(header).then(function (value) {
      fetch(config.get("api") + "/exportar/escala/grade/vencimentos", {
        method: "POST",
        mode: "cors",
        headers: value,
        body: JSON.stringify(datasave),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "alert");
          if (responseJson.status === "success") {
            self.setState({
              overlay: { message: "", type: "", status: "closed" },
            });
            window.open(config.get("cdn") + "/tmp/" + responseJson.data);
            self.setState({
              overlay: { message: "", type: "", status: "closed" },
            });
          }
          self.handleAlert(responseJson.message, responseJson.status, "open");
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        <Topo></Topo>
        <RequestApi ref={"request_api"} handleLoaded={this.handleLoaded} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <div className="container-fluid">
          <div className="conteudo">
            <h3 className="page-title pull-left">Escala com Vencimentos</h3>
            <Link to="/escalas" className="btn btn-default pull-right">
              <i className="fa fa-chevron-left"></i> Voltar
            </Link>
            <div className="clearfix"></div>
            <hr />
            <form onSubmit={this.search}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Escala / Grade:</label>
                    <Select
                      className="form-field-name"
                      name="schedule_grade_id"
                      value={this.state.schedule_grade_id}
                      searchable={true}
                      placeholder={""}
                      onChange={this.handleSelectChangeMulti.bind(
                        this,
                        "schedule_grade_id"
                      )}
                      options={this.state.schedule_grades_list}
                      multi={true}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <button
                      type="submit"
                      className="btn btn-primary btn-inline btn-block"
                    >
                      <i className="fa fa-fw fa-search"></i> Pesquisar
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <hr />
            <button
              className="btn btn-success pull-left"
              onClick={() => {
                this.export();
              }}
            >
              <i className="fa fa-fw fa-file-pdf-o"></i>Exportar XLSX
            </button>
            <div className="clearfix"></div>
            <hr />
            {this.state.open == 1 ? (
              <BootstrapTable
                data={self.state.schedule_grade_group_staffs}
                pagination={true}
                striped={true}
                hover={true}
                options={{
                  exportCSVText: "Exportar CSV",
                  noDataText: "Não há escalas",
                }}
                search={true}
                multiColumnSearch={true}
                searchPlaceholder="Procurar"
              >
                {self.state.table_index.map(function (index) {
                  return (
                    <TableHeaderColumn
                      isKey={index.dataField == "inscription" ? true : false}
                      dataField={index.dataField}
                      width={index.dataField == "name" ? "300" : "150"}
                      dataAlign="center"
                      dataSort={true}
                      filter={{
                        type: "TextFilter",
                        delay: 200,
                        placeholder: "Procurar",
                      }}
                    >
                      {index.text}
                    </TableHeaderColumn>
                  );
                })}
              </BootstrapTable>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default ScheduleGradesExpirationsControl;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/ScheduleGradesExpirationsControl.js